import styled from '@emotion/styled'

export const PendingWithdrawalDetailsStyled = styled('div')({
  display: 'flex',
})
